import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import './App.css';

import './lib/appConfig'; // eslint-disable-line -- side effect: registers axios interceptors at boot
import { SurveyFlow } from './components/SurveyFlow';
import { AdminDashboard } from './components/admin/AdminDashboard';

// Main App Component
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SurveyFlow />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
